/* 
Object:         Documents
Description:    Logic and events for the module Documents
Used in:        Documents
*/

import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum"

import * as appsettings from "../appsettings"
import * as dialog from "../dialog"
import * as navigation from "../navigation"
import * as viewmode from "../viewmode"

/**
 * delete a item (param is event data)
 */
export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour cd 
        event.preventDefault();

        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as DocumentGridVM;

        // Post Data
        $.ajax({
            type: "GET",
            url: appsettings.getUrl("Documents/Delete?documentId=" + dataItem.DocumentID),
            success: function () {

                // Refresh datasource grid 
                $("#DocumentsGrid").data("kendoGrid").dataSource.read();

            }
        });
    }

    function callingCallback(): void {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

/**
 * update a item (param is event data)
 */
export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as DocumentGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Documents/EditItem?documentId=" + dataItem.DocumentID + "&breadcrumbLabel=" + dataItem.Label);
}

/**
 * show a item (param is event data)
 */
export function downloadItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as DocumentGridVM;

    // Define the file URL
    const fileUrl = appsettings.getUrl("Documents/DownloadFile?documentId=" + dataItem.DocumentID);

    // Use jQuery to create an AJAX request to download the file
    $.ajax({
        url: fileUrl,
        type: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
        success: function (data, textStatus, request) {

            var contentDisposition = request.getResponseHeader('Content-Disposition');
            var fileName = contentDisposition.split(';')[1].trim().split('=')[1];

            // Use the HTML5 "download" attribute to download the file
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(data);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            $(link).remove();
        }
    });

    // Show mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);
}

export function visibilityItem(dataItem: DocumentGridVM, nodeId: number): boolean {
    return dataItem.NodeID === nodeId;
}
